import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

export const SchoolCardsSkeleton = (): ReactNode => {
  return (
    <>
      <Skeleton className="hidden h-[400px] rounded-2xl sm:block" />
      <Skeleton className="hidden h-[400px] rounded-2xl sm:block" />
      <Skeleton className="hidden h-[400px] rounded-2xl sm:block" />
      <Skeleton className="h-[400px] rounded-2xl" />
      <Skeleton className="h-[400px] rounded-2xl" />
      <Skeleton className="h-[400px] rounded-2xl" />
      <Skeleton className="hidden h-[400px] rounded-2xl xl:block" />
      <Skeleton className="hidden h-[400px] rounded-2xl xl:block" />
    </>
  )
}
